import React, { useEffect, useState } from "react";
import "./CookieBanner.css";

const STORAGE_KEY = "cookieConsent.v1";

const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const saveConsent = (consent) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  } catch {}
};

const applyConsent = (consent) => {
  // ถ้าใช้ GA4/gtag หรือ GTM ให้ตั้งค่า consent ตามนี้ (ถ้าไม่มี ก็จะข้าม)
  const analyticsGranted = consent.analytics ? "granted" : "denied";
  const marketingGranted = consent.marketing ? "granted" : "denied";

  if (typeof window !== "undefined") {
    // GA4 gtag
    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: marketingGranted,
        analytics_storage: analyticsGranted,
        functionality_storage: "granted",
        security_storage: "granted",
      });
    }
    // Google Tag Manager
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "consent_update",
        ad_storage: marketingGranted,
        analytics_storage: analyticsGranted,
      });
    }
    // Facebook Pixel (ถ้าใช้)
    if (window.fbq) {
      window.fbq("consent", consent.marketing ? "grant" : "revoke");
    }
  }
};

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  // ค่าตั้งต้น: จำเป็น (necessary) เปิดตลอด, analytics/marketing ปิดไว้ก่อน
  const [form, setForm] = useState({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const stored = getStoredConsent();
    if (stored) {
      setForm(stored);
      applyConsent(stored);
      setShowBanner(false);
    } else {
      setShowBanner(true); // ยังไม่เคยยินยอม -> แสดงแบนเนอร์
    }
  }, []);

  const acceptAll = () => {
    const consent = { necessary: true, analytics: true, marketing: true, ts: Date.now() };
    setForm(consent);
    saveConsent(consent);
    applyConsent(consent);
    setShowBanner(false);
    setShowSettings(false);
  };

  const saveSettings = () => {
    const consent = { ...form, necessary: true, ts: Date.now() };
    saveConsent(consent);
    applyConsent(consent);
    setShowSettings(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Banner ด้านล่าง */}
      <div className="ck-banner" role="dialog" aria-label="การยินยอมคุกกี้" aria-live="polite">
        <div className="ck-text">
          เราขอเก็บข้อมูลคุกกี้จากคุณเพื่อช่วยพัฒนาและเสนอข้อมูลข่าวสารบริการ/ผลิตภัณฑ์ที่ตรงกับความสนใจของคุณ
          โดยคุณสามารถเปลี่ยนการตั้งค่าคุกกี้ได้ทุกเมื่อ อ่านเพิ่มเติมที่
          {" "}
          <a href="/cookie-policy" className="ck-link">นโยบายคุกกี้</a>
        </div>
        <div className="ck-actions">
          <button className="ck-btn ck-btn-outline" onClick={() => setShowSettings(true)}>
            ตั้งค่าคุกกี้
          </button>
          <button className="ck-btn ck-btn-primary" onClick={acceptAll}>
            ยอมรับคุกกี้ทั้งหมด
          </button>
        </div>
      </div>

      {/* Modal ตั้งค่า */}
      {showSettings && (
        <div className="ck-modal">
          <div className="ck-modal__dialog" role="dialog" aria-modal="true" aria-label="ตั้งค่าคุกกี้">
            <div className="ck-modal__header">
              <h3>ตั้งค่าคุกกี้</h3>
              <button className="ck-close" onClick={() => setShowSettings(false)} aria-label="ปิด">×</button>
            </div>
            <div className="ck-modal__body">
              <label className="ck-switch">
                <input type="checkbox" checked readOnly />
                <span className="ck-switch__label">
                  <strong>จำเป็น (Necessary)</strong> — จำเป็นต่อการทำงานของเว็บไซต์ (บังคับเปิด)
                </span>
              </label>

              <label className="ck-switch">
                <input
                  type="checkbox"
                  checked={form.analytics}
                  onChange={(e) => setForm((f) => ({ ...f, analytics: e.target.checked }))}
                />
                <span className="ck-switch__label">
                  <strong>วิเคราะห์การใช้งาน (Analytics)</strong> — ช่วยให้เราเข้าใจการใช้งานเพื่อพัฒนาเว็บไซต์
                </span>
              </label>

              <label className="ck-switch">
                <input
                  type="checkbox"
                  checked={form.marketing}
                  onChange={(e) => setForm((f) => ({ ...f, marketing: e.target.checked }))}
                />
                <span className="ck-switch__label">
                  <strong>การตลาด/โฆษณา (Marketing)</strong> — ใช้สำหรับปรับโฆษณาให้ตรงความสนใจ
                </span>
              </label>
            </div>
            <div className="ck-modal__footer">
              <button className="ck-btn" onClick={() => setShowSettings(false)}>ยกเลิก</button>
              <button className="ck-btn ck-btn-outline" onClick={acceptAll}>ยอมรับทั้งหมด</button>
              <button className="ck-btn ck-btn-primary" onClick={saveSettings}>บันทึกการตั้งค่า</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
